// extracted by mini-css-extract-plugin
export default {"objects":"styles_objects__XBf9t","objects--checkbox":"styles_objects--checkbox__ovCxy"};